import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from "./router";
import * as  api from './api/index'
const app = createApp(App);
app.config.globalProperties.$api = api;
app.use(router);
app.use(ElementPlus)
app.mount('#app')
